import { render, staticRenderFns } from "./RegisterMoodle.vue?vue&type=template&id=bff03214&scoped=true"
import script from "./RegisterMoodle.vue?vue&type=script&lang=js"
export * from "./RegisterMoodle.vue?vue&type=script&lang=js"
import style0 from "./RegisterMoodle.vue?vue&type=style&index=0&id=bff03214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff03214",
  null
  
)

export default component.exports